import type { CourseRepository } from '@/domain/port/CourseRepository';
import type { Course } from '@/domain/model/Course';

export class CourseService {
  private readonly courseRepository: CourseRepository;

  constructor(courseRepository: CourseRepository) {
    this.courseRepository = courseRepository;
  }

  getCourse(id: string): Promise<Course> {
    return this.courseRepository.getCourse(id);
  }

  getCoursesByChapter(chapterId: string): Promise<Course[]> {
    return this.courseRepository.getCoursesByChapter(chapterId);
  }
}
